export const metrics = {
  documentTitle: "Metrics",
  title: "Metrics",
  refresh: "Refresh",
  metric_label: "Metric",
  split_by_label: "Split by label",
  add_label_filter: "Add label filter",
  empty: "No metrics match the current filters.",
  columns: {
    metric: "Metric",
    value: "Value",
  },
};
